@if (form) {
    <form
        class="form-entry"
        menuSystem
        [doNotShowTucked]="true"
        [cerrixTab]="tab"
        (changeEvent)="selectedChanged($event)"
        data-uiid="form-entry"
    >
        <div class="detail-page-action-bar">
            <!-- This div has to stay, so the workflow area can be placed correctly. -->
            <button class="btn btn-sm" (click)="previousPage()" [disabled]="selectedIndex <= 0">
                <i class="fas fa-angle-left" aria-hidden="true"></i>
                <span class="d-none d-lg-inline ms-2">{{ 'formEntry.previousPage' | t }}</span>
            </button>
            @if (readOnly) {
                <span class="sub-message">{{ 'formEntry.readonlyViewer' | t }}</span>
            } @else {
                @if (isReview) {
                    <span class="sub-message">{{ 'formEntry.viewingAsReviewer' | t }}</span>
                } @else {
                    <span class="sub-message">{{ 'formEntry.viewingAsAssignee' | t }}</span>
                }
                <div class="workflow-area">
                    @if (selectedIndex === lastPageIndex) {
                        @if (isReview) {
                            <button
                                class="btn btn-danger btn-sm"
                                (click)="completeClick(true)"
                                [disabled]="saveClicked"
                            >
                                <i class="fas fa-times" aria-hidden="true"></i>
                                <span class="d-none d-lg-inline ms-2">{{ 'formEntry.reject' | t }}</span>
                            </button>
                            <button
                                class="btn btn-success btn-sm"
                                (click)="completeClick()"
                                [disabled]="saveClicked"
                            >
                                <i class="fas fa-check" aria-hidden="true"></i>
                                <span class="d-none d-lg-inline ms-2">{{ 'formEntry.accept' | t }}</span>
                            </button>
                        } @else {
                            <button
                                class="btn btn-cerrix btn-sm"
                                (click)="completeClick()"
                                [disabled]="saveClicked"
                            >
                                <i class="fas fa-check" aria-hidden="true"></i>
                                <span class="d-none d-lg-inline">{{ 'formEntry.complete' | t }}</span>
                            </button>
                        }
                    }
                </div>
            }
            @if (selectedIndex < lastPageIndex) {
                <button class="btn btn-sm float-end ms-2" (click)="nextPage()">
                    <span class="d-none d-lg-inline">{{ 'formEntry.nextPage' | t }}</span>
                    <i class="fas fa-angle-right ms-2" aria-hidden="true"></i>
                </button>
            }
            @if (!readOnly && !isReview && selectedIndex !== lastPageIndex) {
                <button
                    class="btn btn-secondary btn-sm float-end"
                    (click)="storeResult(false)"
                    [disabled]="saveClicked"
                >
                    <i class="fas fa-save" aria-hidden="true"></i>
                    <span class="d-none d-lg-inline ms-2">{{ 'formEntry.save' | t }}</span>
                </button>
            }
            @if (allowReopen) {
                <button class="btn btn-warning btn-sm float-end" (click)="reopenClick()">
                    <i class="far fa-undo-alt" aria-hidden="true"></i>
                    <span class="d-none d-lg-inline ms-2">{{ 'formEntry.reopen' | t }}</span>
                </button>
            }
        </div>

        <div
            class="form-pages"
            [attr.name]="form.Title"
            menuicon="fas fa-file-alt"
            menusystemsubmenu
        >
            @if (isReview || reviewComment) {
                <div class="form-group global-comment">
                    @if (isReview) {
                        <cerrix-textarea
                            fieldLabel="{{ 'formEntry.globalReviewComment' | t }}"
                            class="form-control"
                            [(ngModel)]="reviewComment"
                            [ngModelOptions]="{ standalone: true }"
                            identifier="review-comment-{{ result.ResultID }}"
                            placeholder="{{ 'formEntry.reviewMessagePlaceholder' | t }}"
                            (valueChange)="answerChanged = true"
                        ></cerrix-textarea>
                    } @else {
                        <br />
                        <pre class="readonly-comment">{{ reviewComment }}</pre>
                    }
                    <hr />
                </div>
            }

            <!-- Actually defined pages -->
            @for (page of form.Pages; track page; let pI = $index) {
                <div
                    class="detail-page-card"
                    [attr.name]="page.Title"
                    menusystemitem
                    [attr.menuicon]="result.PageResults[pI]._pageIcon"
                >
                    <div class="detail-page-card-title">{{ page.Title }}</div>
                    <div class="detail-page-card-body padded form-group-styling">
                        @if (page.Type === pageTypes.Review) {
                            <div class="review-message">
                                @if (pI !== form.Pages.length - 1) {
                                    <small class="text-muted">
                                        {{
                                            'formEntry.reviewPageAssignedTo'
                                                | t: { userName: result.PageResults[pI].UserName }
                                        }}
                                    </small>
                                    <small class="text-muted">
                                        {{ 'formEntry.reviewingSubmittedAnswers' | t }}
                                        <br />
                                        {{ 'formEntry.fieldCommentInfo' | t }} <br />
                                        {{ 'formEntry.acceptOrRejectInfo' | t }}
                                        <br /><br />
                                        {{ 'formEntry.globalCommentNote' | t }}
                                    </small>
                                }
                            </div>
                        }
                        @for (field of page.Fields; track field) {
                            <div class="form-group">
                                <form-entry-field
                                    [field]="field"
                                    [(answer)]="answers[field.ID]"
                                    [readonly]="
                                        (result && result.PageResults[pI].Completed) ||
                                        (readOnly && !isPreview)
                                    "
                                    [isReview]="isReview"
                                    [(comment)]="comments[field.ID]"
                                    (valueChange)="answerChanged = true"
                                    (answerChange)="answerChanged = true"
                                    (commentChange)="answerChanged = true"
                                >
                                </form-entry-field>
                            </div>
                        }
                    </div>
                </div>
            }

            <!-- Last page if it is a summary page. -->
            @if (form.ShowSummary) {
                <div
                    class="page-fields"
                    menuItemId="menuItemSummary"
                    [attr.name]="'formEntry.summaryMenu' | t"
                    menuicon="fas fa-eye"
                    menusystemitem
                >
                    @for (page of form.Pages; track page; let pI = $index) {
                        <div class="detail-page-card">
                            @if (userIsViewingSummary) {
                                <div>
                                    <div class="detail-page-card-title">
                                        {{ page.Title }}<br />
                                        @if (result.PageResults[pI].UserName) {
                                            <small class="text-muted">
                                                {{
                                                    'formEntry.pageAssignment'
                                                        | t
                                                            : {
                                                                  pageType:
                                                                      page.Type == pageTypes.Entry
                                                                          ? 'entry'
                                                                          : 'review',
                                                                  state: result.PageResults[pI].Completed
                                                                      ? 'completed'
                                                                      : 'assigned',
                                                                  userName: result.PageResults[pI].UserName,
                                                              }
                                                }}
                                            </small>
                                        }
                                    </div>
                                    <div class="detail-page-card-body padded form-group-styling">
                                        @if (page.Type == pageTypes.Review) {
                                            <div class="review-summary-message">
                                                <small class="text-muted"> {{ 'formEntry.reviewPage' | t }} </small>
                                            </div>
                                        }
                                        @for (field of page.Fields; track field) {
                                            <div class="form-group">
                                                <form-entry-field
                                                    [field]="field"
                                                    [answer]="answers[field.ID]"
                                                    [comment]="comments[field.ID]"
                                                    [readonly]="true"
                                                >
                                                </form-entry-field>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>

        <div class="form-bottom-controls mb-2">
            <button class="btn btn-sm" (click)="previousPage()" [disabled]="selectedIndex <= 0">
                <i class="fas fa-angle-left" aria-hidden="true"></i>
                <span class="d-none d-lg-inline ms-2">{{ 'formEntry.previousPage' | t }}</span>
            </button>
            <button
                class="btn btn-sm"
                (click)="nextPage()"
                [disabled]="selectedIndex >= lastPageIndex"
            >
                <span class="d-none d-lg-inline">{{ 'formEntry.nextPage' | t }}</span>
                <i class="fas fa-angle-right ms-2" aria-hidden="true"></i>
            </button>
        </div>

        <div
            class="modal fade"
            tabindex="-1"
            role="dialog"
            id="form-detail-modal"
            data-backdrop="static"
            data-keyboard="false"
            #popupModal
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{
                                'formEntry.workflowTitle'
                                    | t: { state: reviewRejected ? 'rejection' : 'completion' }
                            }}
                        </h5>
                    </div>
                    <div class="modal-body">
                        @if (reviewRejected) {
                            <!-- Review Page get rejection options -->
                            <div class="form-group row">
                                <label for="rejectedPageSelect" class="col-sm-3 col-form-label"
                                    >{{ 'formEntry.rejectToPage' | t }}</label
                                >
                                <div class="col-sm-9">
                                    <ng-select
                                        id="rejectedPageSelect"
                                        name="rejectedPageSelect"
                                        [items]="rejectablePages"
                                        [(ngModel)]="rejectPage"
                                        bindValue="Key"
                                        bindLabel="Value"
                                    >
                                    </ng-select>
                                </div>
                            </div>
                        } @else {
                            <div class="form-group row">
                                <label for="followingUserSelect" class="col-sm-3 col-form-label"
                                    >{{ 'formEntry.followUpUser' | t }}</label
                                >
                                <div class="col-sm-9">
                                    <ng-select
                                        id="followingUserSelect"
                                        name="followingUserSelect"
                                        [items]="followingUsers"
                                        [(ngModel)]="selectedNextUser"
                                        bindValue="Key"
                                        bindLabel="Value"
                                    >
                                    </ng-select>
                                </div>
                            </div>
                        }
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            {{ 'formEntry.close' | t }}
                        </button>
                        <button
                            type="button"
                            class="btn btn-{{
                                isReview ? (reviewRejected ? 'danger' : 'success') : 'cerrix'
                            }}"
                            (click)="storeResult(true)"
                            [attr.disabled]="
                                selectedNextUser === undefined && !isReview ? 'disabled' : null
                            "
                        >
                            <i
                                class="fas fa-{{ reviewRejected ? 'times' : 'check' }}"
                                aria-hidden="true"
                            ></i>
                            <span class="d-none d-lg-inline {{ isReview ? 'ms-2' : '' }}">{{
                                'formEntry.workflowAction'
                                    | t
                                        : {
                                              action: isReview
                                                  ? reviewRejected
                                                      ? 'reject'
                                                      : 'accept'
                                                  : 'complete',
                                          }
                            }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
}
